import { PropsWithChildren } from 'react';

import { ActivityFilter, ActivityList, GolferSelection, MobileActivityFilter } from '@blocks';
import { useActivityList, useLocalStorage } from '@hooks';
import { Spinner, Above, Box, u, ScreenTitle, Below } from '@ui';

import { Navigation } from '../../components/Navigation/Navigation';
import { WelcomeBanner } from '../../components/WelcomeBanner';
import { LINKS } from '../../utils/routes';
import { root, screen } from '../screens.css';

export function ActivityListScreen() {
    const {
        studentId,

        containerRef,
        bottomRef,

        lastSelectedActivityId,
        persistLastSelectedActivityId,

        activities,
        totalActivities,
        isLoadingActivities,
        isFetchingNextPage,
        hasNextPage,
        fetchNextPage,
        refetch,
    } = useActivityList();
    if (isLoadingActivities && !activities) {
        return (
            <ActivityListLayout>
                <Box mt={u(5)}>
                    <Spinner size="l" />
                </Box>
            </ActivityListLayout>
        );
    }

    return (
        <ActivityListLayout>
            <Box
                display="flex"
                position="relative"
                px={{ sm: u(2.5), md: 0 }}
                gap={{ sm: 0, md: u(5) }}
                flexDirection={{ xs: 'column', md: 'row' }}
            >
                <Above bp="md" avoidRendering>
                    <ActivityFilter
                        totalActivities={totalActivities}
                        numberOfActivities={activities?.length}
                        golfers={<GolferSelection studentId={studentId} getOverviewLink={LINKS.getActivities} />}
                    />
                </Above>
                <Below bp="md" avoidRendering>
                    <MobileActivityFilter
                        numberOfActivities={activities?.length ?? 0}
                        totalActivities={totalActivities}
                        golfers={<GolferSelection studentId={studentId} getOverviewLink={LINKS.getActivities} />}
                    />
                </Below>
                <ActivityList
                    ref={containerRef}
                    lastSelectedActivityId={lastSelectedActivityId}
                    isLoading={isLoadingActivities || isFetchingNextPage}
                    activities={activities}
                    showNoResultsMessage={activities.length === 0}
                    currentActivityId={0}
                    hasNextPage={hasNextPage}
                    persistLastSelectedActivityId={persistLastSelectedActivityId}
                    fetchNextPage={fetchNextPage}
                    getActivityLink={LINKS.getActivity}
                    retry={refetch}
                >
                    <Box width="100%" style={{ height: 40 }} ref={bottomRef} />
                </ActivityList>
            </Box>
        </ActivityListLayout>
    );
}

const ActivityListLayout = ({ children }: PropsWithChildren) => {
    const [bannerSeen, setBannerSeen] = useLocalStorage<boolean>('welcomeBannerSeen', false);
    return (
        <div className={root}>
            <ScreenTitle title="Elva Golf — App" />

            <div className={screen}>
                <Navigation />
                {!bannerSeen ? <WelcomeBanner onClose={() => setBannerSeen(true)} /> : null}
                {children}
            </div>
        </div>
    );
};
